import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import type { OnboardingStepDef } from "@/lib/onboarding";

interface WelcomeStepProps {
  readonly greetingText: string;
  readonly steps: readonly OnboardingStepDef[];
  readonly onNext: () => void;
}

export function WelcomeStep({ greetingText, steps, onNext }: WelcomeStepProps): ReactNode {
  return (
    <div className="flex flex-col items-center gap-6 px-4 py-8 text-center">
      {/* Fox mascot placeholder */}
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-primary/10">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-primary">
          <path d="M12 2L3 7v8c0 3 4 6 9 7c5-1 9-4 9-7V7l-9-5z" />
          <circle cx="9" cy="11" r="1" fill="currentColor" />
          <circle cx="15" cy="11" r="1" fill="currentColor" />
          <path d="M9 15c1.5 1.5 4.5 1.5 6 0" />
        </svg>
      </div>

      <h1 className="text-2xl font-bold">{greetingText}</h1>

      <Card className="w-full max-w-md">
        <CardContent className="p-4">
          <h2 className="mb-3 text-lg font-semibold">
            {"\u05DE\u05D4 \u05E0\u05E2\u05E9\u05D4 \u05D4\u05D9\u05D5\u05DD:"}
          </h2>
          <ol className="space-y-2 text-start text-sm text-muted-foreground">
            {steps.map((step, i) => (
              <li key={step.id} className="flex items-center gap-2">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-medium text-primary">
                  {i + 1}
                </span>
                <span>{step.label}</span>
                {!step.required && (
                  <span className="text-xs text-muted-foreground/60">
                    {"\u0028\u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05E0\u05DC\u05D9\u0029"}
                  </span>
                )}
              </li>
            ))}
          </ol>
        </CardContent>
      </Card>

      <Button size="lg" className="min-h-[44px] min-w-[200px] text-lg" onClick={onNext}>
        {"\u0021\u05D1\u05D5\u05D0\u05D5 \u05E0\u05EA\u05D7\u05D9\u05DC"}
      </Button>
    </div>
  );
}
